import styled from 'styled-components'

export const StyledH1 = styled.h1`
  font-size: ${({ theme }) => theme.size.font.large};
  color: ${({ theme }) => theme.color.content.main};
  font-family: ${({ theme }) => theme.font.family.main};
`
